import React from 'react';
import { useMessageStore } from '../../store/messageStore';

interface TypingIndicatorProps {
  roomKey: string;
}

const EMPTY: { userId: string; username: string }[] = [];

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ roomKey }) => {
  const typers = useMessageStore((s) => s.typingUsers[roomKey] ?? EMPTY);

  if (typers.length === 0) return null;

  let text: string;
  if (typers.length === 1) {
    text = `${typers[0].username} est en train d'écrire`;
  } else if (typers.length === 2) {
    text = `${typers[0].username} et ${typers[1].username} sont en train d'écrire`;
  } else if (typers.length === 3) {
    text = `${typers[0].username}, ${typers[1].username} et ${typers[2].username} sont en train d'écrire`;
  } else {
    text = `Plusieurs personnes sont en train d'écrire`;
  }

  return (
    <div className="h-6 px-4 flex items-center gap-1.5 text-xs text-text-muted select-none">
      <span className="inline-flex gap-[2px] items-center">
        <span className="w-1.5 h-1.5 bg-text-muted rounded-full animate-bounce [animation-delay:0ms]" />
        <span className="w-1.5 h-1.5 bg-text-muted rounded-full animate-bounce [animation-delay:150ms]" />
        <span className="w-1.5 h-1.5 bg-text-muted rounded-full animate-bounce [animation-delay:300ms]" />
      </span>
      <span className="truncate">{text}...</span>
    </div>
  );
};

export default TypingIndicator;
